"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROL_TEST_PERCENTAGE = exports.CONTROL_TEST = exports.PREFIX = void 0;
exports.PREFIX = 'GOAL';
exports.CONTROL_TEST = 'A/A';
exports.CONTROL_TEST_PERCENTAGE = 10;
//# sourceMappingURL=experiments.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/constants/experiments.js
// module id = DyrG
// module chunks = 69